import PropTypes from "prop-types";

export const CareerOptionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  annualEarningsMedian: PropTypes.number,
  isSelected: PropTypes.bool,
  outlook: PropTypes.number,
  pathwaySteps: PropTypes.arrayOf(
    PropTypes.shape({
      stepNum: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string,
      isSchoolStep: PropTypes.bool,
    }),
  ),
});
